import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Note } from '../../models/referral';

@Component({
  selector: 'app-edit-referral-note-dialog',
  imports: [
    MatButtonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatDialogModule
  ],
  templateUrl: './edit-referral-note-dialog.component.html',
  styleUrl: './edit-referral-note-dialog.component.scss'
})
export class EditReferralNoteDialogComponent implements OnInit {

  form!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<EditReferralNoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.initForm();

    if (this.data) {
      this.populateForm(this.data);
    }
  }

  initForm() {
    this.form = this.formBuilder.group({
      _subject: [''],
      _comment: ['']
    });
  }

  populateForm(note: Note) {
    this.form.patchValue(note);
  }

  submitNote() {
    let updatedNote = {
      subject: this.form.get('_subject')?.value,
      comment: this.form.get('_comment')?.value
    }
    this.dialogRef.close(updatedNote);
  }

  onCancelEditNote() {
    this.dialogRef.close(undefined);
  }
}